import { useFormik } from "formik";
import React from "react";
import { Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { Button, Container, Form, FormGroup, Row } from "reactstrap";
import * as Yup from "yup";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { useAuth } from "../../../context/AuthContext";
import { handleErrors } from "../../../services/handleErrors";
import { patchNovedadObservations } from "../../../services/novedadesServices";

const Observations = ({ novedad, isAudit }) => {
  const { refreshToken } = useAuth();
  const formik = useFormik({
    initialValues: {
      observations: novedad.observations,
    },
    onSubmit: async ({ observations }) => {
      try {
        const { message } = await patchNovedadObservations(novedad.id, observations);
        toast.success(message);
      } catch (error) {
        handleErrors(error, toast.error, refreshToken, formik);
      }
    },
    validationSchema: Yup.object().shape({
      observations: Yup.string().nullable(),
    }),
  });

  return (
    <>
      <BlurSpinner isLoading={formik.isSubmitting}>
        <Container fluid>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col className="p-0">
                <FormGroup className="normalized_ul">
                  <textarea
                    className={formik.errors.observations && formik.touched.observations ? "form-control error-field" : "form-control"}
                    name="observations"
                    rows={6}
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.observations}
                  />
                  {formik.errors.observations && formik.touched.observations && <div className="input-feedback">{formik.errors.observations}</div>}
                </FormGroup>

                <FormGroup className="mb-0">
                  <Button type="submit" color="primary" disabled={formik.isSubmitting || isAudit}>
                    Grabar
                  </Button>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </Container>
      </BlurSpinner>
    </>
  );
};

export default withRouter(Observations);
